import React from "react";
import "./AboutUsHeader.css";

const AboutUsHeader = () => {
  return (
    <section className="AboutUsHeader-container">
      <div className="AboutUsHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="AboutUsHeader-title">About Us</h1>
          <div className="AboutUsHeader-breadcrumb">
            <button className="btn btn-primary">Home - About Us</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsHeader;
